import http, { url } from '../../http'

const API_URL = "absenteeism-report"

/**
 * Ítem 3.3.6 — Reportes branded firmables de ausentismo.
 * type ∈ { medico, otras, consolidado }; anclado por empresa + año.
 */
class AusentismoReportAPI {

  pdfUrl(type, companyId, year) {
    return url(`${API_URL}/${type}/${companyId}/${year}/pdf`)
  }

  async status(type, companyId, year) {
    return await http(`${API_URL}/${type}/${companyId}/${year}/status`, 'GET')
  }

  async sign(type, companyId, year, payload) {
    return await http(`${API_URL}/${type}/${companyId}/${year}/sign`, 'POST', payload)
  }
}

export default new AusentismoReportAPI()
